/** "m:ss" for a duration in seconds (hours roll into minutes below 100 h). */
export function formatClock(totalSec: number): string {
  const s = Math.max(0, Math.floor(totalSec));
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, "0")}`;
}

/** "12h 05m" / "42m" for playtime. */
export function formatPlaytime(totalSec: number): string {
  const minutes = Math.floor(Math.max(0, totalSec) / 60);
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return h > 0 ? `${h}h ${String(m).padStart(2, "0")}m` : `${m}m`;
}

export function formatInt(n: number): string {
  return Math.round(n).toLocaleString("en-US");
}

/** Ratio with two decimals; "-" when the divisor is zero and there is nothing to show. */
export function formatRatio(num: number, den: number): string {
  if (den === 0) return num === 0 ? "-" : num.toFixed(2);
  return (num / den).toFixed(2);
}

/** Percentage with one decimal; "-" when `total` is zero. */
export function formatPercent(part: number, total: number): string {
  return total > 0 ? `${((part / total) * 100).toFixed(1)}%` : "-";
}
